"use client";

import { motion } from "framer-motion";
import Image from "next/image";
import Link from "next/link";

import { services_care } from "@/data/services";
import { generateWhatsAppLink } from "@/lib/generateWhatsappLink";

import CtaServicesCarousel from "./cta-services-carousel";
import { Button } from "./ui/button";

const CTABanner = () => {
  return (
    <div className="bg-primary relative overflow-hidden rounded-lg md:overflow-visible">
      <Image
        src="/services/pet-brush.svg"
        alt=""
        width={100}
        height={100}
        className="absolute top-10 right-10 h-30 w-30 rotate-20 opacity-5"
      />
      <Image
        src="/services/scissors.svg"
        alt=""
        width={120}
        height={100}
        className="absolute top-25 left-2 h-30 w-30 -rotate-20 opacity-5 lg:top-45"
      />
      <Image
        src="/services/shampoo.svg"
        alt=""
        width={120}
        height={100}
        className="absolute top-70 right-5 h-30 w-30 -rotate-10 opacity-5 lg:right-45"
      />

      <div className="grid grid-cols-1 gap-16 lg:grid-cols-[380px_1fr]">
        <div className="relative hidden lg:block">
          <Image
            src="/img19.png"
            alt=""
            width={450}
            height={400}
            className="absolute bottom-0 left-16"
          />
        </div>
        <div className="p-4 py-10 text-center md:p-16 lg:text-start">
          <motion.h2
            className="text-primary-foreground mb-6 text-2xl font-bold text-balance md:text-4xl"
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
          >
            Beleza e bem-estar completo para seu pet
          </motion.h2>

          <motion.p
            className="text-primary-foreground mb-6 text-center text-base font-normal tracking-wide md:text-lg lg:text-start"
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.2 }}
          >
            Cuidamos do visual, conforto e bem-estar do seu pet com serviços
            completos de banho, tosa e cuidados especiais.
          </motion.p>

          <CtaServicesCarousel />

          <div className="mb-8 hidden grid-cols-1 gap-4 md:grid md:grid-cols-2">
            {services_care.map((service, index) => (
              <div
                className="flex items-center justify-center gap-2 md:justify-start"
                key={index}
              >
                <Image
                  src={"/paw-print.svg"}
                  width={20}
                  height={20}
                  alt="paw"
                />
                <span className="text-white">{service.label}</span>
              </div>
            ))}
          </div>

          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.4 }}
          >
            <Button
              asChild
              size="xl"
              className="group text-white"
              variant="secondary"
            >
              <Link
                href={generateWhatsAppLink(
                  process.env.NEXT_PUBLIC_WHATSAPP_NUMBER || "",
                  "Olá! Gostaria de agendar um serviço de cuidado para meu pet.",
                )}
                target="_blank"
              >
                Agendar Serviço
              </Link>
            </Button>
          </motion.div>
        </div>
      </div>
    </div>
  );
};

export default CTABanner;
